function Ctrl($scope, utilsService) {
  const defaultURL = utilsService.createUrl('/');

  initialize();

  $scope.$watch('config', config => {
    if (!config) return;

    const url = config.url || defaultURL;
    const msg = config.message || url;

    initialize(url, msg);
  });

  function initialize(url, message) {
    $scope.url = url || defaultURL;

    const msg = message || $scope.url;

    $scope.facebookLink = utilsService.facebookLink($scope.url);
    $scope.twitterLink = utilsService.twitterLink($scope.url, msg);
    $scope.emailLink = utilsService.mailtoLink($scope.url, msg);
  }
}

Ctrl.$inject = [
  '$scope',
  'utilsService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/shareBar/controller.js